import React from 'react';
import { element, func } from 'prop-types';
import { useDropzone } from 'react-dropzone';

import { DropZoneS } from './styles';

import { FILE_MIME_EXTS, FILE_MAX_SIZE } from '../../../utils';

const DropZone = ({ children, onDrop }) => {
  const {
    isDragActive,
    getRootProps,
    getInputProps,
  } = useDropzone({
    onDrop,
    accept: FILE_MIME_EXTS,
    maxSize: FILE_MAX_SIZE,
  });

  return (
    <DropZoneS
      {...getRootProps({
        refKey: 'innerRef',
        isDragActive,
      })}
    >
      <input {...getInputProps({
        onClick: event => event.preventDefault(),
      })}
      />
      {children}
    </DropZoneS>
  );
};

DropZone.propTypes = {
  children: element.isRequired,
  onDrop: func.isRequired,
};

export default DropZone;



// WEBPACK FOOTER //
// ./src/components/attachments/drop-zone/index.js